import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=4bdcc7d8&scoped=true&"
import script from "./Sobre.vue?vue&type=script&lang=js&"
export * from "./Sobre.vue?vue&type=script&lang=js&"
import style0 from "./Sobre.vue?vue&type=style&index=0&id=4bdcc7d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcc7d8",
  null
  
)

export default component.exports